import React, { useEffect } from 'react';
import { bases } from '../../json/revisionbases';
import './revisionbases.css';

const RevisionBases = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Los primeros 9 son los documentos principales
  const documentos = bases.slice(0, 9);

  // Los últimos son Manual y Video
  const materialApoyo = bases.slice(9);

  return (
    <main className="revision-bases-page">

      <div className="revision-bases-container">

        {/* ENCABEZADO */}
        <section className="revision-bases-header">

          <div className="revision-bases-icon">
            <i className="fa-solid fa-file-circle-check"></i>
          </div>

          <div className="revision-bases-title-content">

            <h1>Revisión de Bases</h1>

            <p>
              Consulta y descarga la documentación vigente para los
              procedimientos de revisión de bases.
            </p>

            <div className="revision-bases-line">
              <span></span>
            </div>

          </div>

        </section>


        {/* DOCUMENTOS */}
        <section className="revision-bases-grid">

          {documentos.map((item, index) => (

            <a
              key={index}
              href={item.url || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="revision-card"
            >

              <div className="revision-number">
                {index + 1}
              </div>

              <div className="revision-document-icon">
                <i className="fa-solid fa-file-word"></i>
              </div>

              <div className="revision-card-content">

                <h3>
                  {item.nombre}
                </h3>

                <div className="revision-download">
                  <i className="fa-solid fa-download"></i>
                  <span>Descargar documento</span>
                </div>

              </div>

            </a>

          ))}

        </section>


        {/* MATERIAL DE APOYO */}
        {materialApoyo.length > 0 && (

          <section className="revision-support">

            <div className="revision-support-title">

              <div className="revision-support-main-icon">
                <i className="fa-solid fa-book-open"></i>
              </div>

              <div>
                <h2>Material de apoyo</h2>
                <span></span>
              </div>

            </div>


            <div className="revision-support-items">

              {materialApoyo.map((item, index) => {

                const esVideo =
                  item.nombre.toLowerCase().includes('video');

                return (

                  <a
                    key={index}
                    href={item.url || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="revision-support-card"
                  >

                    <div className="revision-support-icon">

                      <i
                        className={
                          esVideo
                            ? 'fa-solid fa-play'
                            : 'fa-solid fa-book-open'
                        }
                      ></i>

                    </div>


                    <div className="revision-support-content">

                      <h3>
                        {item.nombre}
                      </h3>

                      <div className="revision-support-button">

                        <i
                          className={
                            esVideo
                              ? 'fa-solid fa-play'
                              : 'fa-solid fa-arrow-up-right-from-square'
                          }
                        ></i>

                        <span>
                          {esVideo
                            ? 'Ver video'
                            : 'Consultar manual'}
                        </span>

                      </div>

                    </div>

                  </a>

                );

              })}

            </div>

          </section>

        )}

      </div>

    </main>
  );
};

export default RevisionBases;